module.exports = __webpack_public_path__ + "fonts/46cf1067-688d-4aab-b0f7-bd942af6efd8.7c6fbea.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/46cf1067-688d-4aab-b0f7-bd942af6efd8.ttf
// module id = 153
// module chunks = 245 246